import script from "./CReductionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CReductionModal.vue?vue&type=script&setup=true&lang=ts"

import "./CReductionModal.vue?vue&type=style&index=0&id=3135a96f&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3135a96f"]])

export default __exports__